export default __webpack_public_path__ + "static/media/330_dummy2016-wellness01-mobile-de.9626b0c2.png";